export const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-IN'));
export const pct = (v, digits = 1) => (v == null ? '—' : `${(v * 100).toFixed(digits)}%`);
export const money = (v) => (v == null ? '—' : `₹${Number(v).toLocaleString('en-IN')}`);

// A movement of null is "new to this list", which is a different statement from
// "did not move" and must never render as a zero.
export const movement = (m) => {
  if (m === null || m === undefined) return { text: 'new', tone: 'new' };
  if (m === 0) return { text: '—', tone: 'flat' };
  return { text: `${m > 0 ? '▲' : '▼'} ${Math.abs(m)}`, tone: m > 0 ? 'up' : 'down' };
};

export const CLASS_LABEL = {
  branded: 'Branded', competitor: 'Competitor', generic: 'Generic',
};
